import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    parent_id: null, //IdRef, optional // Mã người dùng là cấp trên
    children: [], //array of IdRef, optional // Danh sách mã người dùng cấp dưới
};

// validation form
model.validForm = {
    parent_id: [], //IdRef, optional // Mã người dùng là cấp trên
    children: [], //array of IdRef, optional // Danh sách mã người dùng cấp dưới
};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

// model.fileUploadOption = {
//     AnhDaiDien: {
//         limit: 1,
//         accept: ".jpg, .png, .jpeg",
//         dialogImageUrl: "",
//         dialogVisible: false,
//         fileList: []
//     }
// }

model.tableRules = {
    data: [],
    lengthMenu: [
        10,
        20,
        50,
        100,
        500
    ],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: [
        "",
        ""
    ],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {

        },
        operator: {

        }
    }
};

export default model;